import React from 'react';
import { KoobInputNumber } from '@koob/ui';

export default function RoomRow({
  room,
  roomIndex,
  updateRoomName,
  updateRoomPaxCount,
  updateRoomAdultsCount,
  updateRoomChildrenCount,
  removeRoom,
  t,
  isReadOnly = false,
}) {
  const isPaxDefined = Number(room.paxCount) > 0;
  const isAdultDefined = Number(room.adultsCount) >= 1;

  return (
    <div className="flex items-center gap-3 rounded-lg border border-gray-200 p-3 hover:border-gray-300 transition-all">
      <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center">
        <i className="fa fa-bed text-gray-400 text-sm" />
      </div>

      <input
        type="text"
        className="flex-1 rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-orange-400 focus:ring-1 focus:ring-orange-400 focus:outline-none transition"
        value={room.name || ''}
        onChange={(e) => updateRoomName(roomIndex, e.target.value)}
        disabled={isReadOnly}
        placeholder={t('accommodation.roomNamePlaceholder', 'Room name')}
      />

      <div className="flex items-center gap-1.5">
        <label className="text-xs text-gray-500 uppercase tracking-wide">
          {t('accommodation.pax', 'Pax')}
        </label>
        <div className="w-16">
          <KoobInputNumber
            integer
            min={1}
            value={room.paxCount}
            onValueChange={(value) =>
              updateRoomPaxCount(roomIndex, value ?? '')
            }
            disabled={isReadOnly}
          />
        </div>
      </div>

      <div className="flex items-center gap-1.5">
        <label className="text-xs text-gray-500 font-medium whitespace-nowrap">
          {t('accommodation.adults')}
        </label>
        <div className="w-16">
          <KoobInputNumber
            integer
            min={1}
            value={room.adultsCount}
            onValueChange={(value) =>
              updateRoomAdultsCount(roomIndex, value ?? '')
            }
            disabled={isReadOnly || !isPaxDefined}
          />
        </div>
      </div>

      <div className="flex items-center gap-1.5">
        <label className="text-xs text-gray-500 font-medium whitespace-nowrap">
          {t('accommodation.children')}
        </label>
        <div className="w-16">
          <KoobInputNumber
            integer
            min={0}
            value={room.childrenCount}
            onValueChange={(value) =>
              updateRoomChildrenCount(roomIndex, value ?? '')
            }
            disabled={isReadOnly || !isAdultDefined}
          />
        </div>
      </div>

      {!isReadOnly && (
        <button
          type="button"
          onClick={() => removeRoom(roomIndex)}
          className="flex-shrink-0 p-1 border-none outline-none text-gray-300 hover:text-red-500 transition"
          title={t('accommodation.removeRoom', 'Remove room')}
        >
          <i className="fa-light fa-trash" style={{ fontSize: 15 }} />
        </button>
      )}
    </div>
  );
}
